import React from 'react';
import Layout from './layout';
import headerImage from '../content/paddleboarding.jpg';
import HeroImage from '../components/HeroImage';

const Home = () => {

  return (
    <Layout>
      <HeroImage title='GIRLS CLUB TEESSIDE' headerImage={headerImage}/>

      {/* Text Section */}
      <section className="flex-grow px-4 font-garet  py-10 bg-cream text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4">Welcome</h2>
        <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
        Girls Club Teesside was set up to create opportunities for local women to try new activities in a friendly and safe environment. 
        By all coming in as newbies, we all know what each other is feeling and it doesn't feel quite as daunting.     
        </p>
        <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
          <br/>
        To find all our upcoming events, follow our <a href="https://www.instagram.com/girls_club_teesside/" target='_blank' rel="noreferrer" className='underline hover:text-pink'>Instagram</a> or 
        join our <a href="https://www.facebook.com/groups/360266296904255/" className='underline hover:text-pink' target='_blank' rel="noreferrer">Facebook group</a>. 
        <br/>
        <br/>
        Join our mailing list <a href='/mailing' className='underline hover:text-pink'>here</a>.
        </p>
      </section>
    </Layout>
  );
};

export default Home;
